<ng-container #formDirective=parent-form thr-parent-form>
    <thr-full-data-form-shareholder [shareHolder]="shareHolder" [min]="min" [max]="max" [isDisabled]="isDisabled" (natureChange)="onNatureChange()"></thr-full-data-form-shareholder>

    <ng-container *ngIf="shareHolder.isLegalPerson">
        <h3 class="mat-subheading-1 text-blue font-weight-bold">
            {{ 'form.indicates-shareholder-final'|translate }}
        </h3>
        <thr-full-data-shareholder-table [shareHolders]="shareHolder.shareHolders" [owner]="true" [isDisabled]="isDisabled" (edit)="onEdit($event)" (remove)="onRemove($event)"></thr-full-data-shareholder-table>
        <thr-full-data-form-shareholder [shareHolder]="currentShareHolder" [owner]="true" [min]="0" [isDisabled]="isDisabled" *ngIf="adding || editing"></thr-full-data-form-shareholder>
    </ng-container>

    <div class="row justify-content-between" *ngIf="!isDisabled">
        <ng-container *ngIf="!adding && !editing">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onParentCancel()" *ngIf="showCancel">
                    {{ 'general.cancel'|translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onAdd()" *ngIf="shareHolder.isLegalPerson">
                    {{ 'form.add-other-shareholder-final'|translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid" (click)="onParentSave()">
                    {{ 'form.add-shareholder'|translate }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="adding || editing">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="gray" (click)="onCancel()" *ngIf="shareHolder.shareHolders.length > 0">
                    {{ 'general.cancel'|translate }}
                </button>
            </div>
            <div class="col-12 col-sm-6 col-md-4 mt-3 mt-sm-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!isFormValid" (click)="onSave()">
                    {{ 'form.add-shareholder-final'|translate }}
                </button>
            </div>
        </ng-container>
    </div>
</ng-container>